<div [@routerTransition]>
    <sub-header
        [title]="('ChartOfAccounts' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"
    ></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row mt-3">
                    <div class="col-md-6">
                <div class="form-group m-form__group">
                    <label for="AccountGroupName">{{ l('AccountGroup') }}</label>
                    <select
                        name="chartOfAccount.accountGroupId"
                        [(ngModel)]="chartOfAccount.accountGroupId"
                        class="form-select"
                    >
                        <option value="">{{ l('SelectAAccountGroup') }}</option>

                        <option *ngFor="let item of allAccountGroups" value="{{ item.id }}">
                            {{ item.displayName }}
                        </option>
                    </select>
                </div>
                    </div>
                    <div class="col-md-6">
                <div class="form-group m-form__group">
                    <label for="AccountSubGroupName">{{ l('AccountSubGroup') }}</label>
                    <select
                        name="chartOfAccount.accountSubGroupId"
                        [(ngModel)]="chartOfAccount.accountSubGroupId"
                        class="form-select"
                    >
                        <option value="">{{ l('SelectAAccountSubGroup') }}</option>

                        <option *ngFor="let item of allAccountSubGroups" value="{{ item.id }}">
                            {{ item.displayName }}
                        </option>
                    </select>
                </div>
                    </div>
                    <div class="col-md-6">
                <div class="form-group">
                    <label for="ChartOfAccount_AccountType">{{ l('AccountType') }} *</label>
                    <input
                        type="text"
                        #ChartOfAccount_AccountType="ngModel"
                        id="ChartOfAccount_AccountType"
                        class="form-control"
                        [(ngModel)]="chartOfAccount.accountType"
                        name="AccountType"
                        minlength="0"
                        maxlength="50"
                        required
                    />
                    <validation-messages [formCtrl]="ChartOfAccount_AccountType"></validation-messages>
                </div>
                    </div>
                    <div class="col-md-6">
                <div class="form-group">
                    <label for="ChartOfAccount_Code">{{ l('Code') }} *</label>
                    <input
                        type="text"
                        #ChartOfAccount_Code="ngModel"
                        id="ChartOfAccount_Code"
                        class="form-control"
                        [(ngModel)]="chartOfAccount.code"
                        name="Code"
                        minlength="0"
                        maxlength="30"
                        required
                    />
                    <validation-messages [formCtrl]="ChartOfAccount_Code"></validation-messages>
                </div>
                    </div>
                    <div class="col-md-6">

                <div class="form-group">
                    <label for="ChartOfAccount_Name">{{ l('Name') }} *</label>
                    <input
                        type="text"
                        #ChartOfAccount_Name="ngModel"
                        id="ChartOfAccount_Name"
                        class="form-control"
                        [(ngModel)]="chartOfAccount.name"
                        name="Name"
                        required
                    />
                    <validation-messages [formCtrl]="ChartOfAccount_Name"></validation-messages>
                </div>
                    </div>
                    <div class="col-md-6">
<br />
                <label class="form-check form-check-custom form-check-solid">
                    <input
                        id="ChartOfAccount_IsSystemAccount"
                        #ChartOfAccount_IsSystemAccount="ngModel"
                        name="IsSystemAccount"
                        [(ngModel)]="chartOfAccount.isSystemAccount"
                        type="checkbox"
                        class="form-check-input"
                    />
                    <span class="form-check-label">
                        {{ l('IsSystemAccount') }}
                    </span>
                </label>
                <validation-messages [formCtrl]="ChartOfAccount_IsSystemAccount"></validation-messages>
                    </div>
                    <div class="col-md-6">
                <br />
                <label class="form-check form-check-custom form-check-solid">
                    <input
                        id="ChartOfAccount_IsBank"
                        #ChartOfAccount_IsBank="ngModel"
                        name="IsBank"
                        [(ngModel)]="chartOfAccount.isBank"
                        type="checkbox"
                        class="form-check-input"
                    />
                    <span class="form-check-label">
                        {{ l('IsBank') }}
                    </span>
                </label>
                <validation-messages [formCtrl]="ChartOfAccount_IsBank"></validation-messages>
                    </div>
                </div>


                
                


            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button
                        (click)="save()"
                        class="btn btn-primary blue me-2"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>

                    <button
                        *ngIf="!this.chartOfAccount.id"
                        (click)="saveAndNew()"
                        class="btn btn-primary blue"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAndNew') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
